import React, { useState } from 'react';
import { message } from 'antd';
import { useCategoryTree } from '../../../../../../../hooks/queries/category/useCategoryTree';
import Table from '../../../../../../../components/_table/Table/Table';
import Modal from '../../../../../../../components/Modal/Modal';
import { categoryTreeColumn } from './categoryTreeColumn';

interface SearchCategoryUrlModalProps {
  onOk: (mainCategoryId: number, subCategoryIdList?: number[]) => void;
  onClose: () => void;
}

const SearchCategoryUrlModal = (props: SearchCategoryUrlModalProps) => {
  const { onOk, onClose } = props;
  const [selectedMainCategory, setSelectedMainCategory] = useState<number>();
  const [selectedSubCategories, setSelectedSubCategories] = useState<number[]>([]);
  const categoryTree = useCategoryTree();

  const subCategories = categoryTree.flatMap((tree) => tree.subCategories);
  const subCategoryIdList = subCategories.map((item) => item.id);

  const handleCheck = (idList: number[], id: number) => {
    // 전체 선택 클릭 시 아무런 동작을 하지 않도록 함
    if (!id) return;

    const targetMainCategory = categoryTree.find((item) => item.id === id);
    const targetSubCategory = subCategories.find((item) => item.id === id);

    if (targetMainCategory) {
      setSelectedMainCategory(targetMainCategory.id);
      setSelectedSubCategories([]);
      return;
    }

    if (targetSubCategory) {
      setSelectedMainCategory(targetSubCategory.parentId);
      setSelectedSubCategories(idList.filter((id) => subCategoryIdList.includes(id)));
    }
  };

  const handleOk = () => {
    if (!selectedMainCategory) {
      message.error('상품 카테고리를 최소 1개는 선택하셔야 합니다.');
      return;
    }
    onOk(selectedMainCategory, selectedSubCategories);
  };

  return (
    <Modal
      title="상품 카테고리 검색"
      isOpen={true}
      width={720}
      height={650}
      isFooter={true}
      onOk={handleOk}
      onClose={() => onClose()}
    >
      <div className="search-item-modal">
        <div className="help-text">*APP/WEB 에 노출중인 카테고리 리스트</div>

        <Table
          columns={categoryTreeColumn}
          rowKey={(record: { id: number }) => record.id}
          onCheck={handleCheck}
          selectedList={[selectedMainCategory, ...selectedSubCategories]}
          list={categoryTree.map((tree) => {
            const { subCategories, ...rest } = tree;
            return { ...rest, children: subCategories };
          })}
          size="small"
          scroll={{ x: true }}
          bordered={true}
        />
      </div>
    </Modal>
  );
};

export default SearchCategoryUrlModal;
